import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

import HttpClient from "../../../../helpers/HttpClient";
import { showToast } from "../../../../utils/toast";
import OverlayLoader from "../../../OverlayLoader";
import ButtomCustom from "../../../ButtonRound";
import MobileStepper from "../MobileStepper";
import ExcerciseContainer from "../ExcerciseContainer";
import AlertModal from "../../../Tests/components/AlertModal";

const StyledContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  border: "1px solid #e0e0e0",
  borderRadius: "10px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  backgroundColor: "white",
  maxWidth: "1000px",
  margin: "auto",
});

const EvaluationReviewContainer = ({
  courseCode,
  data,
  onFinalize,
  onContinue,
  config,
}) => {
  const [modalProps, setModalProps] = useState({
    open: false,
    title: "Traducción",
    content: "",
    buttonText: "Aceptar",
  });
  const [openLoader, setOpenOpenLoader] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [exersiceTypesNavigated, setExerciseTypesNavigated] = useState([])
  const [exersiceTypes, setExerciseTypes] = useState([
    "VOC_PRA",
    "GRAMATICA",
    "ESCRIBIR",
    "PRONUNC",
    "LEER_ESC",
    "ESC_SEL_IMG",
    "ESC_SEL_FRA",
    "CREA_ORAC",
    "IMG_SEL_RESP"
  ]);
  const authState = useSelector((state) => state.auth);
  const userId =
    authState && authState.user ? authState.user.email : "test";
  const [currentIndex, setCurrentIndex] = useState(0);
  const [arrayPercentages, setArrayPercentages] = useState(
    Array(exersiceTypes.length).fill(0)
  );

  const setResultForContainer = (percentage) => {
    console.log(percentage);
    setArrayPercentages((prevAnswers) => {
      const newPercentages = [...prevAnswers];
      newPercentages[currentIndex] = percentage;
      return newPercentages;
    });

    setExerciseTypesNavigated((prevNavigated) => {
      const newPrevNavigated = [...prevNavigated];
      newPrevNavigated[currentIndex] = exersiceTypes[currentIndex];
      return newPrevNavigated;
    });

    
  };

  const handleNext = async () => {
    if (currentIndex == exersiceTypes.length - 1) {
      await execFinalizeQuiz();
    } else {
      if (!arrayPercentages[currentIndex]) {
        setResultForContainer(0);
      }
      setCurrentIndex((prevIndex) =>
        Math.min(prevIndex + 1, exersiceTypes.length - 1)
      );
    }
  };

  const handlePrevious = () => {
    setArrayPercentages((prevAnswers) => {
      const newPercentages = [...prevAnswers];
      newPercentages[currentIndex] = 0;
      return newPercentages;
    });
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const execFinalizeQuiz = async (silence) => {
    if (!silence) {
      setOpenOpenLoader(true);
    }
    const totalPercentage = arrayPercentages.length * 100;
    const sumPercentages = arrayPercentages.reduce(
      (partialSum, a) => partialSum + a,
      0
    );
    const percentage = Math.round((100 * sumPercentages) / totalPercentage);
    const request = await HttpClient().post(
      `/step/exercise-result-q/${userId}/${courseCode}/${data.tipo}/${data.cod_leccion}`,
      {
        percentage: percentage,
      }
    );
    setOpenOpenLoader(false);
    if (!silence) {
      if (request.error) {
        showToast("No se pudo guardar el progreso. Intenta nuevamente.", "error");
        return;
      }
      setIsSaved(true);
    }

    if (percentage >= config.porcentaje_aprobacion_evaluacion && data.tipo != "REVIEW") {
      onFinalize();
    } 
    if (data.tipo == "REVIEW") {
      onFinalize();
    }
    if (!silence) {
      setModalProps({
        ...modalProps,
        title: `Has finalizado ${
          data.tipo == "REVIEW" ? " el Repaso" : "la Evaluación"
        }`,
        content: quizResult(percentage),
        open: true,
        buttonText: "Aceptar",
      });
    }
  };

  const quizResult = (percentage) => {
    return (
      <Stack
        direction="row"
        spacing={12}
        sx={{ margin: "auto", textAlign: "center" }}
      >
        <Typography
          variant="subtitle1"
          align="center"
          color={"primary"}
          sx={{ fontWeight: "bold" }}
        >
          {"Puntaje: "}
        </Typography>
        {percentage >= config.porcentaje_aprobacion_evaluacion ? (
          <Chip icon={<CheckIcon />} color="success" label={percentage} />
        ) : (
          <Chip icon={<CloseIcon />} color="error" label={percentage} />
        )}
      </Stack>
    );
  };

  useEffect(() => {
    setModalProps({
      ...modalProps,
      title: `Iniciar ${data.tipo == "REVIEW" ? "Repaso" : "Evaluación"}`,
      content: `Da click en el botón para comenzar `,
      //content: resultadoEvaluacion(80),
      open: true,
      buttonText: "Comenzar",
    });
  }, []);

  useEffect(() => {
    console.log(arrayPercentages);
  }, [arrayPercentages]);

  useEffect(() => {
    const execRequest = async () =>{
      await execFinalizeQuiz(true);
    }
    if (data.tipo == "REVIEW") {
      if (exersiceTypes.length == [...new Set(exersiceTypesNavigated)].length) {
        execRequest()
      }
    }
  }, [exersiceTypesNavigated]);

  return (
    <>
      <StyledContainer>
        {/*<Typography variant="subtitle1" align="center" color={"primary"} sx={{ fontWeight: "bold" }}>
                        {"Hola"}
                  </Typography>*/}
        <OverlayLoader open={openLoader} />
        <ExcerciseContainer
          courseCode={courseCode}
          data={data}
          containerStepExcersiseType={exersiceTypes[currentIndex]}
          haveContainer={true}
          key={`${exersiceTypes[currentIndex]}${data.id}`}
          configPercentage={config.porcentaje_ejercicios}
          numQuestionsForUse={
            data.tipo == "REVIEW"
              ? config.preguntas_repaso
              : ["EVSU", "EVSM"].includes(data.tipo)
              ? config.preguntas_evaluacion
              : 0
          }
          onFinalize={() => {}}
          onContinue={() => {}}
          setResultForContainer={setResultForContainer}
        />
      </StyledContainer>

      <MobileStepper
        steps={exersiceTypes.length}
        activeStep={currentIndex}
        disabledPrevious={
          data.tipo == "REVIEW" ? (currentIndex == 0 ? true : false) : true
        }
        disabledNext={false}
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        previousText={"Anterior lección"}
        nextText={
          currentIndex == exersiceTypes.length - 1
            ? "Finalizar"
            : "Siguiente Lección"
        }
        hidePrevious={data.tipo == "REVIEW" ? false : true}
      />

      {isSaved ? (
        <ButtomCustom
          sx={{ marginTop: 1 }}
          onClick={() => {
            onContinue();
          }}
          variant="contained"
          rounded
        >
          Continuar
        </ButtomCustom>
      ) : null}
      <AlertModal
        open={modalProps.open}
        title={modalProps.title}
        content={modalProps.content}
        buttonText={modalProps.buttonText}
        onButtonClick={() => {
          setModalProps({
            ...modalProps,
            title: "",
            content: "",
            open: false,
          });
          if (isSaved) {
            onContinue();
          }
        }}
      />
    </>
  );
};

export default EvaluationReviewContainer;
